var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatinum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22741",
    "data-name": "Group 22741",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 109.944,
    height: 128.494,
    viewBox: "0 0 109.944 128.494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.136,
    y1: 0.31,
    x2: 0.841,
    y2: 0.895,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b69482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9bbae"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.136,
    y1: 0.31,
    x2: 0.841,
    y2: 0.895,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.136,
    y1: 0.31,
    x2: 0.841,
    y2: 0.895,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.136,
    y1: 0.31,
    x2: 0.841,
    y2: 0.895,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.389,
    y1: 0.273,
    x2: 0.73,
    y2: 0.969,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#57111f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#8a1c32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.65,
    y1: 0.194,
    x2: 0.345,
    y2: 0.815,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#691525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#9b1f37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.158,
    y1: 0.23,
    x2: 0.863,
    y2: 0.787,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.158,
    y1: 0.23,
    x2: 0.864,
    y2: 0.787,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13908",
    "data-name": "Path 13908",
    d: "M6444.784,43.8l5.372,10.782,11.911,1.774-8.586,8.443,1.985,11.88-10.683-5.565L6434.1,76.68l1.991-11.88-8.592-8.443,11.911-1.774Z",
    transform: "translate(-6389.812 -43.8)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13909",
    "data-name": "Path 13909",
    d: "M6014.908,358.7l3.822,7.674,8.48,1.266-6.116,6.012,1.42,8.456-7.605-3.958-7.606,3.958,1.415-8.456-6.117-6.012,8.48-1.266Z",
    transform: "translate(-5991.271 -339.164)",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13910",
    "data-name": "Path 13910",
    d: "M5829.535,766.7l2.966,5.949,6.575.98-4.739,4.659,1.092,6.551-5.894-3.065-5.894,3.065,1.1-6.551L5820,773.63l6.569-.98Z",
    transform: "translate(-5820 -721.853)",
    fill: "url(#linear-gradient-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13911",
    "data-name": "Path 13911",
    d: "M7025.2,358.7l-3.821,7.674-8.48,1.266,6.117,6.012-1.415,8.456,7.6-3.958,7.606,3.958-1.415-8.456,6.117-6.012-8.48-1.266Z",
    transform: "translate(-6938.895 -339.164)",
    fill: "url(#linear-gradient-4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13912",
    "data-name": "Path 13912",
    d: "M7294.335,766.7l-2.965,5.949-6.57.98,4.74,4.659-1.1,6.551,5.894-3.065,5.894,3.065-1.1-6.551,4.74-4.659-6.57-.98Z",
    transform: "translate(-7193.926 -721.853)",
    fill: "url(#linear-gradient-5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13913",
    "data-name": "Path 13913",
    d: "M6640.084,1492.6l12.123,29.871-13.643-2.86.05-.019-7.786,11.558-12.128-29.871Z",
    transform: "translate(-6569.15 -1402.719)",
    fill: "url(#linear-gradient-6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13914",
    "data-name": "Path 13914",
    d: "M6287.2,1500.577l-12.544,29.7-7.631-11.663.05.019-13.68,2.661,12.544-29.691Z",
    transform: "translate(-6226.512 -1401.781)",
    fill: "url(#linear-gradient-7)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13915",
    "data-name": "Path 13915",
    d: "M6244.077,665.944c0,1.694-2.066,3.2-2.321,4.82-.26,1.663,1.235,3.735.727,5.3-.515,1.594-2.947,2.388-3.7,3.865s.019,3.921-.956,5.261-3.536,1.352-4.715,2.531-1.185,3.735-2.531,4.715-3.779.2-5.261.955-2.271,3.183-3.865,3.7c-1.569.509-3.635-.986-5.3-.726-1.619.254-3.126,2.32-4.82,2.32s-3.2-2.066-4.82-2.32c-1.663-.261-3.734,1.235-5.3.726-1.595-.515-2.389-2.947-3.865-3.7s-3.921.019-5.261-.955-1.353-3.536-2.531-4.715-3.734-1.185-4.715-2.531-.2-3.778-.956-5.261-3.182-2.271-3.7-3.865c-.508-1.57.987-3.635.727-5.3-.254-1.619-2.32-3.127-2.32-4.82s2.066-3.2,2.32-4.82c.26-1.663-1.235-3.735-.727-5.3.516-1.594,2.947-2.388,3.7-3.865s-.018-3.921.955-5.261,3.537-1.352,4.715-2.531,1.185-3.735,2.532-4.715,3.777-.2,5.26-.955,2.271-3.183,3.865-3.7c1.57-.509,3.636.986,5.3.726,1.619-.254,3.126-2.32,4.82-2.32s3.2,2.066,4.82,2.32c1.663.261,3.735-1.235,5.3-.726,1.6.515,2.389,2.947,3.865,3.7s3.921-.019,5.261.955,1.352,3.536,2.53,4.715,3.735,1.185,4.716,2.531.2,3.778.955,5.261,3.183,2.271,3.7,3.865c.509,1.57-.986,3.635-.726,5.3C6242.011,662.743,6244.077,664.25,6244.077,665.944Z",
    transform: "translate(-6156.354 -596.635)",
    fill: "url(#linear-gradient-8)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_422",
    "data-name": "Ellipse 422",
    cx: 24.462,
    cy: 24.462,
    rx: 24.462,
    ry: 24.462,
    transform: "translate(30.51 44.847)",
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_423",
    "data-name": "Ellipse 423",
    cx: 22.154,
    cy: 22.154,
    rx: 22.154,
    ry: 22.154,
    transform: "translate(32.818 47.155)",
    fill: "url(#linear-gradient-9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinum);
export default __webpack_public_path__ + "static/media/Platinum.d102adf3cc9c18804820380488fe56fe.svg";
export { ForwardRef as ReactComponent };